import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PACKAGES = [
  { label:'3 Night Kashmir',  to:'/tours/beautiful-3-night-kashmir-tour' },
  { label:'4 Night Kashmir',  to:'/tours/short-4-night-kashmir-tour' },
  { label:'5 Night Kashmir',  to:'/tours/incredible-5-night-kashmir-tour' },
  { label:'6 Night Kashmir',  to:'/tours/unique-6-night-tour-kashmir' },
  { label:'5 Night Ladakh',   to:'/tours/magnificent-5-night-ladakh-tour' },
  { label:'8 Night Kashmir',  to:'/tours/take-an-8-night-kashmir-tour' },
];

const DESTINATIONS = ['Srinagar','Gulmarg','Pahalgam','Sonamarg','Ladakh','Doodhpathri','Yusmarg','Gurez Valley'];
const QUICK_LINKS  = [
  { label:'Home',          to:'/' },
  { label:'All Packages',  to:'/tours' },
  { label:'Houseboats',    to:'/houseboats' },
  { label:'Destinations',  to:'/destinations' },
  { label:'Activities',    to:'/activities' },
  { label:'About Us',      to:'/about' },
  { label:'Contact Us',    to:'/contact' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const year = new Date().getFullYear();

  return (
    <footer style={{ background:'var(--dark)', color:'rgba(255,255,255,0.75)', fontFamily:"'Inter',sans-serif" }}>

      {/* Main Footer */}
      <div style={{ padding:'5rem 0 3.5rem', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1.8fr 1fr 1fr 1fr', gap:'3rem' }}>

            {/* Brand */}
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:'0.65rem', marginBottom:'1.5rem' }}>
                <div style={{ width:42, height:42, borderRadius:11, background:'linear-gradient(135deg,#0F4C81,#3AAFA9)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem', color:'#fff', fontWeight:700, boxShadow:'0 4px 14px rgba(15,76,129,0.40)', flexShrink:0 }}>✦</div>
                <div style={{ lineHeight:1.15 }}>
                  <div style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:'1.05rem', color:'#fff' }}>Query Tours and</div>
                  <div style={{ fontFamily:"'Poppins',sans-serif", fontSize:'0.62rem', fontWeight:700, letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--secondary)' }}>Travels</div>
                </div>
              </div>
              <p style={{ fontSize:'0.9rem', lineHeight:1.8, marginBottom:'1.75rem', maxWidth:300, color:'rgba(255,255,255,0.65)' }}>
                Kashmir's most trusted luxury travel company. Crafting unforgettable journeys since 2008 with passion, expertise, and heart.
              </p>

              {/* Contact */}
              <div style={{ display:'flex', flexDirection:'column', gap:'0.75rem', marginBottom:'2rem' }}>
                {[
                  { icon:'📞', text:'+91 7006478276', href:'tel:+917006478276' },
                  { icon:'✉️', text:'querytoursandtravels@gmail.com', href:'mailto:querytoursandtravels@gmail.com' },
                  { icon:'📍', text:'Dal Lake Road, Srinagar, J&K 190001', href:'#' },
                ].map((c,i) => (
                  <a key={i} href={c.href} style={{ display:'flex', alignItems:'flex-start', gap:'0.65rem', fontSize:'0.85rem', color:'rgba(255,255,255,0.70)', transition:'color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.color='#fff'}
                    onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.70)'}>
                    <span style={{ fontSize:'1rem', flexShrink:0, marginTop:'0.05rem' }}>{c.icon}</span>
                    {c.text}
                  </a>
                ))}
              </div>

              {/* Social */}
              <div style={{ display:'flex', gap:'0.5rem' }}>
                {[['📸','https://instagram.com'],['📘','https://facebook.com'],['▶️','https://youtube.com'],['🐦','https://twitter.com']].map(([icon, url], i) => (
                  <a key={i} href={url} target="_blank" rel="noopener noreferrer"
                    style={{ width:38, height:38, borderRadius:9, background:'rgba(255,255,255,0.08)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.1rem', border:'1px solid rgba(255,255,255,0.12)', transition:'all 0.2s' }}
                    onMouseEnter={e => { e.currentTarget.style.background='var(--primary)'; e.currentTarget.style.borderColor='var(--primary)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.08)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.12)'; }}>
                    {icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 style={{ fontFamily:"'Poppins',sans-serif", fontWeight:700, fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'0.12em', color:'#fff', marginBottom:'1.5rem' }}>Quick Links</h4>
              <ul style={{ display:'flex', flexDirection:'column', gap:'0.6rem' }}>
                {QUICK_LINKS.map(({ label, to }) => (
                  <li key={to}>
                    <Link to={to} style={{ fontSize:'0.88rem', color:'rgba(255,255,255,0.65)', transition:'color 0.2s', display:'flex', alignItems:'center', gap:'0.4rem' }}
                      onMouseEnter={e => { e.currentTarget.style.color='var(--accent)'; }}
                      onMouseLeave={e => { e.currentTarget.style.color='rgba(255,255,255,0.65)'; }}>
                      <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--secondary)', display:'inline-block', flexShrink:0 }} />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Packages */}
            <div>
              <h4 style={{ fontFamily:"'Poppins',sans-serif", fontWeight:700, fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'0.12em', color:'#fff', marginBottom:'1.5rem' }}>Popular Packages</h4>
              <ul style={{ display:'flex', flexDirection:'column', gap:'0.6rem' }}>
                {PACKAGES.map(({ label, to }) => (
                  <li key={to}>
                    <Link to={to} style={{ fontSize:'0.88rem', color:'rgba(255,255,255,0.65)', transition:'color 0.2s', display:'flex', alignItems:'center', gap:'0.4rem' }}
                      onMouseEnter={e => { e.currentTarget.style.color='var(--accent)'; }}
                      onMouseLeave={e => { e.currentTarget.style.color='rgba(255,255,255,0.65)'; }}>
                      <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--accent)', display:'inline-block', flexShrink:0 }} />
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Destinations + Newsletter */}
            <div>
              <h4 style={{ fontFamily:"'Poppins',sans-serif", fontWeight:700, fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'0.12em', color:'#fff', marginBottom:'1.5rem' }}>Destinations</h4>
              <div style={{ display:'flex', flexWrap:'wrap', gap:'0.4rem', marginBottom:'2rem' }}>
                {DESTINATIONS.map(d => (
                  <Link key={d} to={`/destinations`} style={{ padding:'0.25rem 0.65rem', background:'rgba(255,255,255,0.07)', border:'1px solid rgba(255,255,255,0.12)', borderRadius:100, fontSize:'0.78rem', color:'rgba(255,255,255,0.70)', transition:'all 0.2s', fontFamily:"'Poppins',sans-serif", fontWeight:500 }}
                    onMouseEnter={e => { e.currentTarget.style.background='rgba(58,175,169,0.20)'; e.currentTarget.style.color='var(--secondary)'; e.currentTarget.style.borderColor='var(--secondary)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.07)'; e.currentTarget.style.color='rgba(255,255,255,0.70)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.12)'; }}>
                    {d}
                  </Link>
                ))}
              </div>

              <h4 style={{ fontFamily:"'Poppins',sans-serif", fontWeight:700, fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'0.12em', color:'#fff', marginBottom:'0.85rem' }}>Newsletter</h4>
              <p style={{ fontSize:'0.82rem', color:'rgba(255,255,255,0.60)', marginBottom:'0.85rem', lineHeight:1.6 }}>Get exclusive deals & Kashmir travel tips.</p>
              <form onSubmit={e => { e.preventDefault(); setEmail(''); }} style={{ display:'flex', gap:0 }}>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email" required
                  style={{ flex:1, padding:'0.65rem 0.9rem', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.18)', borderRight:'none', borderRadius:'10px 0 0 10px', color:'#fff', fontSize:'0.85rem', outline:'none', fontFamily:"'Inter',sans-serif" }} />
                <button type="submit" style={{ padding:'0.65rem 1rem', background:'var(--accent)', color:'var(--dark)', fontWeight:700, borderRadius:'0 10px 10px 0', border:'none', cursor:'pointer', fontSize:'0.82rem', fontFamily:"'Poppins',sans-serif", transition:'background 0.2s', whiteSpace:'nowrap' }}
                  onMouseEnter={e => e.currentTarget.style.background='var(--accent-dark)'}
                  onMouseLeave={e => e.currentTarget.style.background='var(--accent)'}>
                  Join
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Awards Row */}
      <div style={{ padding:'1.5rem 0', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
        <div className="container">
          <div style={{ display:'flex', flexWrap:'wrap', gap:'2rem', alignItems:'center', justifyContent:'center' }}>
            {[
              ['🏆','TripAdvisor Certificate of Excellence'],
              ['⭐','4.9/5 Google Rating (800+ Reviews)'],
              ['✅','J&K Tourism Certified'],
              ['🔒','Secure & Verified Payments'],
              ['💳','EMI Available'],
            ].map(([icon, label], i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:'0.5rem', fontSize:'0.82rem', color:'rgba(255,255,255,0.55)', fontFamily:"'Poppins',sans-serif", fontWeight:500 }}>
                <span style={{ fontSize:'1rem' }}>{icon}</span>
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ padding:'1.25rem 0' }}>
        <div className="container">
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'0.75rem' }}>
            <p style={{ fontSize:'0.82rem', color:'rgba(255,255,255,0.45)', margin:0 }}>
              © {year} Query Tours and Travels. All rights reserved.
            </p>
            <div style={{ display:'flex', gap:'1.25rem', flexWrap:'wrap' }}>
              {['Privacy Policy','Terms & Conditions','Cancellation Policy'].map(lbl => (
                <Link key={lbl} to="/contact" style={{ fontSize:'0.8rem', color:'rgba(255,255,255,0.45)', transition:'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color='rgba(255,255,255,0.80)'}
                  onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.45)'}>
                  {lbl}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width:960px) {
          footer > div:first-child > div > div[style*="grid-template-columns"] {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width:600px) {
          footer > div:first-child > div > div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}
